exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tender fieldset[data-v-046beace]{padding:10px}.ms-data[data-v-046beace]{color:#d4d3d3}.icon[data-v-046beace]{height:15px;width:15px;float:left;margin-top:5px;margin-right:5px;font-size:11px}.svg[data-v-046beace]{overflow:hidden;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-046beace","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/User_messages.vue
// module id = 500
// module chunks = 0